import API from "api/axiosInstance";
import {
  setIsLoading,
  setListKaryawanSO,
  setListPeserta,
  setListStockopname,
  setMessage,
  setStatus,
} from "./index";

export const fetchListSO = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/agenda-so");
    dispatch(setIsLoading(false));
    dispatch(setListStockopname(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddAgendaSO = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/agenda-so", reqData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteAgendaSO = (no_register) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/notpresent-agenda`, { no_register });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchImportAgendaSO =
  (no_register, id, lokasi) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.post(`/importbarang`, {
        id,
        no_register,
        lokasi,
      });
      dispatch(setMessage(response.data.message));
      dispatch(setStatus("success"));
      dispatch(setIsLoading(false));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(
        setMessage(error.response.data.message ?? "Ada Kendala di Server")
      );
      dispatch(setStatus("failed"));
    }
  };

// PESERTA
export const fetchListPesertaSO = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/peserta");
    dispatch(setIsLoading(false));
    dispatch(setListPeserta(response.data.list_peserta));
    dispatch(setListKaryawanSO(response.data.list_karyawan));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
export const fetchAddPesertaSO = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/peserta", reqData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeletePesertaSO = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/delete-peserta/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchResetPesertaSO = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/reset-peserta`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
